<template>
  <div>
    <super-search-view
      ref="superSearch"
      :focus-knowledge="focusKnowledge"
      :is-search-no-steps="isSearchNoSteps"
      :search-type="props.searchType"
      :is-top="positionIsTop"
      :config="getConfig()"
      :item-is-favorite="itemIsFavorite"
      :search-language="selectedLanguage"
      @select-result="handleGoToEntity({ ...$event, deepLoading: true })"
      @cancel="emit('cancel')"
      @copy-link="copyLink({ ...$event, lang: selectedLanguage })"
      @open-in-web="openInWeb({ ...$event, lang: selectedLanguage })"
      @toggle-favorite="toggleFavorite"
      @feedback="
        goToFeedback({
          modalContentId: '',
          source: 'search',
          lang: selectedLanguage,
        })
      "
    />
  </div>
</template>

<script setup lang="ts">
import {
  useKnowledgeStore,
  useAdminStore,
  useFavoritesStore,
} from '@getmayday/vue-modules';
import useEntities from '../../composables/useEntities';

import type SuperSearch from '@getmayday/vue-modules/dist/lib/src/modules/search/pages/SuperSearch.vue';
const knowledgeStore = useKnowledgeStore();
const adminStore = useAdminStore();
const { focusKnowledge, selectedLanguage } = storeToRefs(knowledgeStore);
const { itemIsFavorite } = useFavoritesStore();
const { isSearchNoSteps } = storeToRefs(adminStore);

const { positionIsTop } = storeToRefs(useConfigStore());

const props = defineProps({
  searchType: { type: String, default: 'home' },
  enableShortKeys: { type: Boolean, default: false },
});

const emit = defineEmits(['select-entity', 'cancel']);
const {
  goToEntity,
  toggleFavorite,
  favoriteIds,
  copyLink,
  openInWeb,
  getConfig,
  goToFeedback,
} = useEntities();

const handleGoToEntity = (entity: { id: string; type: string }) => {
  emit('select-entity');
  if (props.searchType === 'quick') {
    return goToEntity({ ...entity, fromToast: true });
  }
  goToEntity(entity);
};

// SHORT KEY
const superSearch = ref<typeof SuperSearch>();

const focusSearch = () => {
  superSearch.value?.focusInput();
};

defineExpose({
  focusSearch,
});

// SHORTCUT KEYS
onMounted(() => {
  if (props.enableShortKeys) {
    document.addEventListener('keydown', keyboardCommands);
  }
});

onUnmounted(() => {
  if (props.enableShortKeys) {
    document.removeEventListener('keydown', keyboardCommands);
  }
});

const keyboardCommands = (e: KeyboardEvent) => {
  if (e.key === 'K' && e.ctrlKey && e.shiftKey) {
    focusSearch();
  }
};
</script>
